import { useMutation } from '@apollo/client';
import { useTranslation } from 'react-i18next';
import {
  NetworkDeviceGroupDevicesDocument,
  NetworkUngroupedDevicesDocument,
} from '~/pages/device-groups/queries/devices.generated';
import { useNotifications, type ApiOptions } from '../helpers';
import { AddDevicesToDeviceGroupFromSettingsDocument } from './add-devices.generated';

export const useAddDevicesToDeviceGroupFromSettings = (
  options: ApiOptions<typeof AddDevicesToDeviceGroupFromSettingsDocument> = {},
) => {
  const { t } = useTranslation();
  return useMutation(AddDevicesToDeviceGroupFromSettingsDocument, {
    ...useNotifications(AddDevicesToDeviceGroupFromSettingsDocument, {
      failure: (error) => error.message || t('api.common.error_generic'),
      success: (data) => {
        const count = data.addDevicesToDeviceGroup?.addedIds.length ?? 0;
        const name = data.addDevicesToDeviceGroup?.deviceGroup.name;
        return t('api.device_groups.add_devices_success_plural', { count, name });
      },
    }),

    refetchQueries: [NetworkUngroupedDevicesDocument, NetworkDeviceGroupDevicesDocument],

    ...options,
  });
};
